<template lang="pug">
  div
    div
      p.margin-medium-top.label {{ pagamentos.length > 0 ? pagamentos[0].receita.tipoReceita.descricao : '' }}
      app-display(label="Tipo:", :content="'À vista'")
      app-display(label="Valor Principal Total:", :content="pagamentos.length > 0 ? formatValorPrincipal() : '-'")
      app-display(label="Valor de Ajustes e Multas:", :content="formatValorMulta() ? formatValorMulta() :  'R$ 0,00'")
      app-display(label="Taxa de Serviço do DAE:", :content="formatValorTaxa() ? formatValorTaxa() : 'R$ 0,00'")

      el-row
        el-table(
          stripe
          :data='[pagamentos[0]]',
        )
          el-table-column(type='expand')
            template(slot-scope='props')
              div(v-for="(boleto, index) in pagamentos", :key="boleto.id")
                div()
                  el-row(
                    type="flex",
                    justify="space-between",
                    align="bottom"
                  )
                    p.label {{index + 1 + 'ª via'}}

                    el-tooltip.item(
                      effect='dark',
                      :content="'Baixar DAE'",
                      placement="left"
                    )
                      el-button.btn(
                        type="text",
                        @click="downloadBoleto(boleto)",
                        size="mini",
                      )
                        span
                          font-awesome-icon.icon(icon="file-pdf" size="2x")

                  el-row.divider

                  app-display(label="Valor Total:", :content="formatValor(boleto.valorPrincipal)")
                  app-display(label="Situação:", :content="getSituacaoBoleto(boleto)")
                  app-display(label="Vencimento:", :content="formatData(boleto.dataVencimento)")

          el-table-column(
            label='Parcela'
            prop="descricaoParcela"
          )

          el-table-column(
            label='Valor',
            prop="valorPrincipal"
            :formatter="formatMoneyProp"
          )

          el-table-column(
            label='Status'
            prop="situacao"
            :formatter="getSituacaoBoletoAtual"
          )

          el-table-column(
            label='Vencimento'
            prop="dataVencimento"
            :formatter="formatDataProp"
          )
    el-button.margin-top(
      v-if="isVoltar",
      type="default",
      @click="voltar",
      name="voltar"
    )
      span.center
        i.fa.fa-chevron-left
        b &nbsp Voltar
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'

export default {

  components: {
    AppDisplay,
    AppDivider
  },

  data () {
    return {
      pagamentos: []
    }
  },

  props: {
    numeroProcesso: {
      required: true
    },
    isVoltar: {
      type: Boolean,
      default: false
    },
    descricao: {
      type: String
    },
    referenciaParcela: {
      type: Number
    },
    codigoReceita: {
      type: String
    },
    idProcesso: {
      type: Number
    },
    idBoleto: {
      type: Number
    }
  },
  async mounted () {
    if (!this.referenciaParcela) {
      this.pagamentos = await this.getBoletosByProcessoByTipoReceita({
        numeroProcesso: this.numeroProcesso,
        codigoReceita: this.codigoReceita,
        id: this.idBoleto
      })
    } else {
      this.pagamentos = await this.getBoletosByProcessoByParcela({
        processo: this.idProcesso,
        referenciaParcela: this.referenciaParcela
      })
    }
    this.pagamentos.sort((a, b) => a.id - b.id)
    this.pagamentos[0].descricaoParcela = this.descricao
  },

  methods: {
    ...mapActions({
      getBoletosByProcessoByParcela: 'dae/getBoletosByProcessoByParcela',
      getBoletosByProcessoByTipoReceita: 'dae/getBoletosByProcessoByTipoReceita',
      downloadDae: 'dae/downloadDae'
    }),

    formatTipo (tipo) {
      return 'Parcelado'
      // return tipo === 'PRAZO' ? 'Parcelado' : 'À vista'
    },

    formatValor (valor) {
      return valor ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },

    formatValorMulta () {
      const index = this.pagamentos?.length - 1
      const valorMulta = this.pagamentos[index]?.valorMulta + this.pagamentos[index]?.valorCorrecao
      return valorMulta ? valorMulta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },
    formatValorTaxa () {
      const index = this.pagamentos?.length - 1
      return this.pagamentos[index]?.valorTaxaDae ? this.pagamentos[index]?.valorTaxaDae.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },

    formatValorPrincipal () {
      const index = this.pagamentos?.length - 1
      return this.pagamentos[index]?.valorPrincipal ? this.pagamentos[index]?.valorPrincipal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },

    formatValorTotal (valor) {
      const valorTotal = valor.valorPrincipal + valor.valorCorrecao + valor.valorAcrescimos + valor?.valorMulta + valor.valorTaxaDae
      return valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },

    async downloadBoleto (boleto) {
      await this.downloadDae(boleto.receita.id)
    },
    formatMoneyProp (prop) {
      return this.pagamentos.length > 0 ? this.pagamentos[this.pagamentos.length - 1].valorPrincipal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },

    getStatus (prop) {
      const boletoAtual = prop.boletos.find(boleto => boleto.ativo === true)
      return this.getSituacaoBoleto(boletoAtual)
    },

    getSituacaoBoleto (prop) {
      switch (prop.situacao) {
        case 'AGUARDANDO_PAGAMENTO':
          return 'Aguardando Pagamento'
        case 'VENCIDO':
          return 'Vencido'
        case 'QUITADO':
          return `Pago em: ${moment(prop.dataPagamento).format('DD/MM/YYYY')}`
        default: return 'Cancelado'
      }
    },

    getSituacaoBoletoAtual (prop) {
      return this.pagamentos.length > 0 ? this.getSituacaoBoleto(this.pagamentos[this.pagamentos.length - 1]) : null
    },

    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    },

    formatDataProp (prop) {
      return this.pagamentos.length > 0 ? moment(this.pagamentos[this.pagamentos.length - 1].dataVencimento).format('DD/MM/YYYY') : null
    },

    getReceita (parcelas) {
      const parcela = parcelas[parcelas.length - 1]
      const descricaoBoleto = parcela.boletos.find(b => b.ativo).receita.descricao
      return descricaoBoleto === null ? '-' : descricaoBoleto
    },

    voltar () {
      this.$router.push({
        name: 'caixa-entrada-cof'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}

.divider {
  border: 1px solid #dfe4ed;
  margin-bottom: 10px;
}

.btn {
  padding: 5px;
  color: #33b281;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPagamentoGestaoVtn.vue